import { NumberTextField } from '@montugroup/design-system';
import { useDebouncedCallback } from '@montugroup/frontend-common';

const COUNT_INPUT_WIDTH = 88;

type StocktakeItemCountInputProps = {
  productId: number;
  count: number | undefined;
  debounceMs: number;
  onCountChange: (productId: number, value: number | undefined) => void;
};

export function StocktakeItemCountInput({ productId, count, debounceMs, onCountChange }: StocktakeItemCountInputProps) {
  const debouncedOnCountChange = useDebouncedCallback(onCountChange, debounceMs);
  return (
    <NumberTextField
      id={String(productId)}
      variant="standard"
      allowNegative={false}
      decimalScale={0}
      placeholder="—"
      value={count ?? ''}
      onValueChange={(values) => debouncedOnCountChange(productId, values.floatValue)}
      sx={{ width: COUNT_INPUT_WIDTH, input: { textAlign: 'right', fontVariantNumeric: 'tabular-nums' } }}
    />
  );
}
